import { Plan, SubscriptionPlans } from './types';

export const firstLastNameValidationRule = {
    firstName: {
        presence: true,
        length: {
            minimum: 1,
            message: '^This field is required',
        },
    },
    lastName: {
        presence: true,
        length: {
            minimum: 1,
            message: '^This field is required',
        },
    },
};

export function getPlanDetails(plans: SubscriptionPlans, planCode: string) {
    return plans.monthly.find((plan) => plan.code === planCode) || plans.yearly.find((plan) => plan.code === planCode);
}

export function getDefaultPlan(plans: SubscriptionPlans) {
    return plans.monthly.find((plan) => plan.settings.default);
}

export function getPlanSettings(plan: Plan) {
    return [
        {
            name: 'SEO Analysis',
            value: plan.settings.seo_analysis_limit,
        },
        {
            name: 'Monitored Websites',
            value: plan.settings.max_tracked_websites,
        },
        {
            name: 'Monitored Keywords',
            value: plan.settings.max_keywords,
        },
        {
            name: 'Monitoring Regions',
            value: plan.settings.max_monitored_regions,
        },
        {
            name: 'Analyzed Competitors',
            value: plan.settings.max_competitors,
        },
        {
            name: 'Deep Analysis - Websites',
            value: plan.settings.dp_max_domains,
        },
        {
            name: 'Deep Analysis - Monitored URLs',
            value: plan.settings.dp_max_urls,
        },
        {
            name: 'Team members',
            value: (plan.settings.max_team_members as number) > 0 ? plan.settings.max_team_members : 'Not included',
        },
        {
            name: 'White Label Reports',
            value: plan.settings.allow_white_label_reports ? 'Included' : 'Not included',
        },
    ];
}
